export default class DragHint extends Phaser.Group {
  constructor(game, x, y, hintId, gameHud, playVO) {
    super(game);

    this.gameHud = gameHud;

    this.circle1 = this.game.make.image(0, 0, 'drag_area');
    this.circle1.anchor.set(0.5);
    this.circle2 = this.game.make.image(0, 0, 'drag_area');
    this.circle2.anchor.set(0.5);
    this.hand = this.game.make.image(0, 0, 'hand');
    this.hand.anchor.set(0, 0.5);

    if (this.game.deviceMetric.platform.type === 'desktop') {
      this.scale.set(0.5);
    }

    this.circle1.alpha = 0;
    this.circle2.alpha = 0;
    this.hand.alpha = 0;

    this.addChild(this.circle1);
    this.addChild(this.circle2);
    this.addChild(this.hand);

    this.x = x;
    this.y = y;

    this.steps = 0;
    this.slide();

    playVO && this.gameHud.state.hintsController.displayHint(null, null, 'hint_target_0' + hintId);
  }

  get depth() {
    return this.y + 1100;
  }

  slide() {
    this.circle1.x = 0;
    this.circle2.x = 0;
    this.hand.x = 0;

    this.circle1.alpha = 0;
    this.circle2.alpha = 0;
    this.hand.alpha = 0;

    // circle 2
    const tween1 = this.game.add
      .tween(this.circle2)
      .to({ alpha: 1 }, 250, Phaser.Easing.Quadratic.Out);
    const tween2 = this.game.add
      .tween(this.circle2)
      .to({ x: 300 }, 800, Phaser.Easing.Quadratic.Out, false, 400);
    const tween3 = this.game.add
      .tween(this.circle2)
      .to({ alpha: 0 }, 250, Phaser.Easing.Quadratic.Out, false, 250);
    tween1.chain(tween2, tween3);

    // hand
    const tween4 = this.game.add
      .tween(this.hand)
      .to({ alpha: 1 }, 250, Phaser.Easing.Quadratic.Out);
    const tween5 = this.game.add
      .tween(this.hand)
      .to({ x: 300, angle: 19 }, 800, Phaser.Easing.Quadratic.Out, false, 400);
    const tween6 = this.game.add
      .tween(this.hand)
      .to({ alpha: 0 }, 250, Phaser.Easing.Quadratic.Out, false, 350);
    tween4.chain(tween5, tween6);
    tween6.onComplete.addOnce(this.endSlide, this);

    //
    const tween7 = this.game.add
      .tween(this.circle1)
      .to({ alpha: [0.7, 0], x: [150, 300] }, 800, Phaser.Easing.Quadratic.Out, false, 800);

    //
    tween1.start();
    tween4.start();
    tween7.start();
  }

  endSlide() {
    if (this.steps === 0) {
      this.steps++;
      this.slide();
    } else {
      this.gameHud.hideDragHint();
      this.destroy();
    }
  }
}
